// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609290031/js/" + chunkId + "." + {"44":"cc199f29","225":"1507c569","481":"fdb57a5a","486":"ca82dd66","770":"f53c0fc2"}[chunkId] + ".0.32267532078765016.chunk.js";
};